import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Select } from '@sainsburys-tech/bolt'

import { by } from '../../../utils'

const StockStatus = {
  NO_STOCK: ' - Out of stock',
  LOW_STOCK: ' - Hurry, low stock!',
  LOTS_OF_STOCK: ''
}

const getAvailabilityText = quantity => {
  const available = parseInt(quantity, 10)
  if (available === 0) {
    return StockStatus.NO_STOCK
  }
  if (available >= 0 && available < 6) {
    return StockStatus.LOW_STOCK
  }
  return StockStatus.LOTS_OF_STOCK
}

const mapStateToAvailabilityInfoProps = (state, ownProps) => {
  const { type, combinations } = ownProps
  const options = combinations
    .filter(combination => combination.attributes?.find(by.typeOf(type)))
    .map(combination => {
      const { partNumber, attributes, price } = combination

      const { availability = {} } = state

      const { data = {}, meta = {} } = availability

      const { requestDone, errorDetail } = meta

      const { quantityAvailable = 0 } = data[partNumber] || {}

      const isAvailable = !requestDone
        ? true // Assume availability until request is done
        : errorDetail
        ? true // Return true on error so customer can still add to trolley
        : quantityAvailable > 0
      const { value } = attributes?.find(by.typeOf(type))
      const disabled = !isAvailable || !partNumber
      const priceText = price ? ` - £${parseFloat(price).toFixed(2)}` : ''
      const message = requestDone && !errorDetail ? getAvailabilityText(quantityAvailable) : ''
      const text = disabled ? `${value} - Out of stock` : `${value}${priceText}${message}`
      return {
        title: text,
        value: partNumber,
        disabled
      }
    })
  return { options }
}

// TODO When redux 7 use useSelector also now is duplication code with TilesSizePicker
const mapStateToAvailabilityProps = (state = {}, ownProps = {}) => {
  const { availability = {} } = state

  const { meta = {} } = availability

  const { requestDone, errorDetail } = meta

  return {
    status: {
      requestDone,
      errorDetail
    },
    ...mapStateToAvailabilityInfoProps(state, ownProps)
  }
}
export class SizePickerSelect extends Component {
  render() {
    const { partNumber: rootPartNumber, selectPartNumber, options } = this.props
    const onChange = event => selectPartNumber(event.target.value)()
    return <Select value={rootPartNumber} onChange={onChange} options={options} data-test='size-drop-down' />
  }
}
SizePickerSelect.propTypes = {
  partNumber: PropTypes.string.isRequired
}
export default connect(mapStateToAvailabilityProps)(SizePickerSelect)
export { getAvailabilityText, mapStateToAvailabilityInfoProps, mapStateToAvailabilityProps }
